import e, { useMemo as f, useEffect as C } from "react";
import { useSetAtom as b, useAtomValue as h } from "jotai";
import { totalChildrenAtom as E } from "./index26.mjs";
import { getConfigPropertyAtomCreator as A, ConfigProperty as g } from "./index13.mjs";
import { RoomInput as r } from "./index226.mjs";
import t from "./index227.mjs";
const y = ({
  setAmountAdults: l,
  setAmountChildren: n,
  limitAdults: m,
  limitChildren: i,
  amountAdults: s,
  amountChildren: c,
  showChildren: d = !0
}) => {
  const o = b(E), u = h(
    f(
      () => A(g.MAX_CHILDREN),
      []
    )
  ), a = Number(u) > 0;
  return C(() => {
    a || o(0);
  }, [a, o]), /* @__PURE__ */ e.createElement("div", { className: t.container }, /* @__PURE__ */ e.createElement("div", { className: t.input_container, "data-testid": "adults-stepper" }, /* @__PURE__ */ e.createElement("div", { className: t.label }, I18n.t("booking_form.adults")), /* @__PURE__ */ e.createElement(
    r,
    {
      maxAmount: m,
      onChange: (p) => l(Math.max(1, p)),
      value: s,
      disabled: !1,
      onDisabledClick: () => {
      }
    }
  )), a && d ? /* @__PURE__ */ e.createElement("div", { className: t.input_container, "data-testid": "children-stepper" }, /* @__PURE__ */ e.createElement("div", { className: t.label }, I18n.t("booking_form.children")), /* @__PURE__ */ e.createElement(
    r,
    {
      maxAmount: i,
      onChange: n,
      value: c,
      disabled: !1,
      onDisabledClick: () => {
      }
    }
  )) : null);
};
export {
  y as GuestsStepper
};
